export const emailValidationRules = ({ message }: { message?: string }) => ({
  required: true,
  pattern: {
    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: message,
  },
});
